import { MarkedOptions } from 'ngx-markdown';
import { Renderer as MarkedRenderer } from 'marked';

export function markedOptionsFactory(): MarkedOptions {
  const renderer = new MarkedRenderer();

  renderer.link = (href: string, _: unknown, text: string) => {
    if (!/(http(s?)):\/\//i.test(href ?? '')) {
      href = 'https://' + href;
    }

    return `<a target="_blank" rel="nofollow" href=${href}>${text}</a>`;
  };

  return {
    renderer,
  };
}
